import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getFunctions, type Functions } from "firebase/functions";
import { readFirebaseConfig, isFirebaseConfigured } from "@/auth/firebase";

let app: FirebaseApp | undefined;
let firestore: Firestore | undefined;
let functions: Functions | undefined;

export function getCloudApp(): FirebaseApp | null {
  if (!isFirebaseConfigured()) return null;
  const config = readFirebaseConfig();
  if (!config) return null;
  if (!app) {
    app = getApps().length > 0 ? getApp() : initializeApp(config);
  }
  return app;
}

export function getCloudFirestore(): Firestore | null {
  const a = getCloudApp();
  if (!a) return null;
  if (!firestore) firestore = getFirestore(a);
  return firestore;
}

export function getCloudFunctions(): Functions | null {
  const a = getCloudApp();
  if (!a) return null;
  if (!functions) functions = getFunctions(a);
  return functions;
}
